
























import Vue from 'vue'
import {Component, Inject} from 'vue-property-decorator'
import {Observer} from 'mobx-vue'

import {NavBar} from '../../stores/NavBar'
import {RootStore} from '../../stores/RootStore'

import NavBarItem from './NavBarItem.vue'
import NavBarContainer from './NavBarContainer.vue'

@Observer
@Component({components: {
    NavBarItem,
    NavBarContainer
}})
export default class NavigationBar extends Vue {
    @Inject()
    private readonly rootStore!: RootStore

    navBar!: NavBar

    created() {
        this.navBar = this.rootStore.navBar
    }

    mounted() {
        window.addEventListener('resize', this.overflow)
        /** After layout and before render handle overflow */
        window.requestAnimationFrame(this.overflow)
    }

    /**
     * Moves menu items into the "more" container until the navbar is no
     * longer overflowing.
     */
    overflow() {
        const el = this.$el as HTMLElement
        const list = this.$refs['list'] as HTMLElement

        const mainGroup = this.$refs['group-main'] as HTMLElement

        /**
         * Check for overflow. At different zoom levels this could be off by one in the positive
         * even though no overflow is occuring. Testing indicates checking for negative difference
         * works at all zoom levels.
         */
        if (el.offsetHeight - el.scrollHeight < 0) {
            this.navBar.overflowOne()
            /**
             * Continue to force layout until no longer overflowing.
             * This provides for the least amount of flicker on page load.
             **/
            this.$forceUpdate()
            window.requestAnimationFrame(this.overflow)
        } else if (mainGroup.offsetTop + mainGroup.offsetHeight + 240 < el.offsetHeight) {
            this.navBar.showOne()
            window.requestAnimationFrame(this.overflow)
        }
    }
}
